export default "__VITE_ASSET__PvsVbu$2__"